import { keyframes } from '@emotion/react';

// The "live" pulse: a ring that fades in as it grows, then fades out. Used by the live-event
// indicator and the leaderboard's live-state column, which only differ in how far the ring
// grows and how long one cycle takes.
export const pulsate = (endScale: number) => keyframes`
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(${endScale}, ${endScale});
    opacity: 0;
  }
`;
